import { StateCreator } from "zustand";
import { DBTGithubConfigData } from "../../../BrightBot/types";
import { ConfigInput, updateConfigValues } from "./dbtSliceUtils";

export interface DBTGithubConfigState {
  github_config: DBTGithubConfigData | null;
}

export interface DBTGithubConfigActions {
  setDBTGithubConfig: (config: DBTGithubConfigData) => void;
  setDBTGithubConfigValues: (config: ConfigInput<DBTGithubConfigData>) => void;
  clearDBTGithubConfig: () => void;
  hasGithubConfig: () => boolean;
}

export interface DBTGithubConfigSlice extends DBTGithubConfigState {
  githubActions: DBTGithubConfigActions;
}

const initialState: DBTGithubConfigState = {
  github_config: null,
};

export const createDBTGithubConfigSlice: StateCreator<
  DBTGithubConfigSlice,
  [],
  [],
  DBTGithubConfigSlice
> = (set, get) => ({
  ...initialState,
  githubActions: {
    setDBTGithubConfig: (config: DBTGithubConfigData) => {
      set((state) => ({
        github_config: { ...state.github_config, ...config },
      }));
    },
    setDBTGithubConfigValues: (config: ConfigInput<DBTGithubConfigData>) =>
      set((state) => ({
        github_config: updateConfigValues(state.github_config, config),
      })),
    clearDBTGithubConfig: () =>
      set(() => ({
        github_config: null,
      })),
    hasGithubConfig: () => Boolean(get().github_config),
  },
});
